
















import { Component, Prop, Vue, Emit } from 'vue-property-decorator';
import * as Common from '@/tenant/common';
import * as Components from '@/tenant/components';

@Component
export default class RptStockBalance extends Vue {

  // 出荷予定表用プロパティ
  public reportTemplate: Common.ReportTemplate = null;
  public segment: Common.Segment = null;
  public warehouse: Common.Counterpart = null;
  public commodityCategory: number = null;
  public categoryGroupCommodity: Common.CategoryGroup = Common.CategoryGroup.Commodity;
  public closingDate: Date = null;
  public onExcelExport :boolean = false;
  public closingDateFlag : Common.dateFlags = Common.dateFlags.default;

  public mounted(){
    if ((this.$parent as any).favoriteLoaded == false){    
      var query: Common.StockBalanceReportTemplateQuery = new Common.StockBalanceReportTemplateQuery();
      this.$api.execute(query).then(obj => {
        var items: Common.ReportTemplate[] = new Array();
        items = (obj as Common.LoadResult).result;
        if (items.length > 0) this.reportTemplate = items[0];
      });
    }
    this.closingDate = new Date().getCalendarDate();

    (this.$refs.StockBalanceDialog as Components.ListDialog).showDialog();
  }
  public async onReportGenerate(){
    var query: Common.StockBalanceReportQuery = new Common.StockBalanceReportQuery();

    // クエリの設定
    query.templateId = this.reportTemplate.id;
    query.segment = this.segment;
    query.commodityCategory = this.commodityCategory;
    query.warehouse = this.warehouse;
    query.closingDate = this.closingDate;
    query.onExcelExport = this.onExcelExport;    
   this.$api.download(query);
  }
}
